export enum RowTabs {
  DETAILS = 'Details',
  COSTING = 'Costing',
  PRICING = 'Pricing',
  UOMS = 'UOMS',
  INVENTORY = 'Inventory',
  HISTORY = 'History',
}
